<template>
  <div v-if="!isShowingLoading" :class="$style['container']">
    <SideBar />

    <div :class="[$style['content'], {[$style['menuExpaned']]: isMenuExpanded}]">

      <MonthlyInfo :initial-assets="initialAssets" :current-assets="currentAssets" :month-assets="monthAssets" :month-percent="monthPercent" :all-gain="allGain" />
  
      <div style="display: flex;flex-direction: column; margin-top: 10px;">
        <LatestProfits :profits="profits"/>
      </div>

      <div :class="$style['box-g']">
        <LineChart :profits="dataChart" />
      </div>

      <div style="display: flex;flex-direction: column; margin-top: 15px;">
        <EarningsProjections :projection-daily="projectionDaily" :projectionMonth="projectionMonth" :deposits-monthly="depositsMonthly" />
      </div>

      <div style="display: flex;flex-direction: column; margin-top: 10px;">
        <ExchangesList :exchanges="exchanges" />
      </div>
  
    </div>

  </div>
</template>

<script>

import SideBar from '@components/SideBar.vue';
import MonthlyInfo from '@/components/MonthlyInfo.vue';
import LineChart from '@/components/LineChart.vue';
import EarningsProjections from '@/components/EarningsProjections.vue';
import ExchangesList from '@/components/ExchangesList.vue';
import LatestProfits from '@/components/LatestProfits.vue';
import dashboardService from '@/services/dashboardService';

export default {
  name: 'DashboardPage',

  data() {
    return {
      loading: true,
      initialAssets: 0,
      currentAssets: 0,
      monthAssets: 0,
      monthPercent: 0,
      allGain: 0,
      projectionDaily: 0,
      projectionMonth: 0,
      chartData: [],
      exchanges: [],
      dataChart: [],
      profits: [],
      depositsMonthly: 0
    };
  },

  components: {
    SideBar,
    MonthlyInfo,
    LineChart,
    EarningsProjections,
    ExchangesList,
    LatestProfits
  },

  async mounted() {
    await this.fetchData()
  },

  computed: {
    isMenuExpanded() {
      return this.$store.getters['helpers/isMenuExpanded'];
    },
    isShowingLoading() {
      return this.$store.getters['helpers/isShowingLoading'];
    },
  },

  methods: {
    async fetchData() {
      this.$store.dispatch('helpers/showLoading')
      try {
        const {
          monthlyPerformance,
          exchangeInfo,
          pastPerformance,
          withdrawsAporte
        } = await dashboardService.getData();

        this.initialAssets   = monthlyPerformance.start_value
        this.currentAssets   = monthlyPerformance.current_value
        this.monthAssets     = monthlyPerformance.gain
        this.monthPercent    = monthlyPerformance.gain_percent
        this.projectionDaily = monthlyPerformance.prediction_next_day
        this.projectionMonth = monthlyPerformance.prediction_result
        this.allGain = monthlyPerformance.all_gain

        if (exchangeInfo?.exchange_infos.length > 0) {
          this.exchanges = exchangeInfo.exchange_infos.filter(item => item.current_value > 0)
          this.exchanges = this.exchanges.sort((a, b) => b.current_value - a.current_value);
        }

        this.profits = pastPerformance

        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();

        this.depositsMonthly = withdrawsAporte
          .filter(item => {
            const itemDate = new Date(item.date);
            return (
              item.type_amount === "aporte" &&
              item.status === "processed" &&
              itemDate.getMonth() === currentMonth &&
              itemDate.getFullYear() === currentYear
            );
          })
          .reduce((sum, item) => sum + item.amount, 0);

      } catch (error) {
        console.error('Dashboard Error', error)
        this.resetDashboardData()
      } finally {
        this.$store.dispatch('helpers/hideLoading');
      }
    },
    resetDashboardData() {
      this.initialAssets     = null;
      this.currentAssets     = null;
      this.monthAssets       = null;
      this.monthPercent      = null;
      this.projectionDaily   = null;
      this.projectionMonth   = null;
      this.depositsMonthly   = null;
      this.exchanges         = [];
      this.profits           = [];
    }
  }
}
</script>

<style lang="scss" module>
  .container {
    width: 100%;
    display: flex;

    .content {
      flex: 1;
      padding: 20px 20px 20px 0;
      overflow-x: hidden;
      overflow-y: auto;

      @include respond-to(null, 'xs') {
        padding: 10px 10px 10px 0 !important;
      }

      &.menuExpaned {
        position: absolute;
        margin-left: 50px;
        height: 100%;
        width: -webkit-fill-available;
      }
    }

    .box-g {
      display: flex;
      gap:25px;
      margin-top: 15px;
      align-items: stretch;

      @include respond-to(null, 'xs') {
        gap: 15px !important;
      }

      @include respond-to(null,'md') {
        flex-direction: column;
        flex-wrap: wrap;
      }
    }

  }
</style>
